export default __webpack_public_path__ + "static/whitelabel_homeSVG-497c53248c82caebda0581301cb7d3a6.svg";